import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  changeCampaignState,
  ChangeCampaignStateRequest,
  getAdReport,
  GetAdReportRequest,
  GetAdReportResponse,
  getCampaignAds,
  GetCampaignAdsRequest,
  GetCampaignAdsResponse,
  getPanelAds,
  GetPanelAdsRequest,
  GetPanelAdsResponse,
} from "./ordersList.api";
import {
  GetAdReportErrorMessages,
  GetCampaignAdsErrorMessages,
  GetPanelAdsErrorMessages,
} from "./ordersList.error";
import { CampaignErrorMessages } from "../orderAd/orderAd.error";
import { AdState } from "core/orderAd/orderAd.entity";

export const getPanelAdsThunk = createAsyncThunk(
  "ordersList/GetPanelAds",
  async (request: GetPanelAdsRequest, { rejectWithValue, getState }) => {
    const { response, error } = await getPanelAds(request);
    if (error) {
      toast.info(GetPanelAdsErrorMessages[error]);
      return rejectWithValue(error);
    }
    return response;
  }
);

export const getCampaignAdsThunk = createAsyncThunk(
  "ordersList/GetCampaignAds",
  async (request: GetCampaignAdsRequest, { rejectWithValue, getState }) => {
    const { response, error } = await getCampaignAds(request);
    if (error) {
      toast.info(GetCampaignAdsErrorMessages[error]);
      return rejectWithValue(error);
    }
    return response;
  }
);

export const getAdReportThunk = createAsyncThunk(
  "ordersList/GetAdReport",
  async (request: GetAdReportRequest, { rejectWithValue, getState }) => {
    const { response, error } = await getAdReport(request);
    if (error) {
      toast.info(GetAdReportErrorMessages[error]);
      return rejectWithValue(error);
    }
    return response;
  }
);

export const changeCampaignStateThunk = createAsyncThunk(
  "ordersList/ChangeCampaignState",
  async (
    request: ChangeCampaignStateRequest,
    { rejectWithValue, getState }
  ) => {
    const { response, error } = await changeCampaignState(request);
    if (error) {
      toast.info(CampaignErrorMessages[error]);
      return rejectWithValue(error);
    }
    return response;
  }
);
